<template>
  <div>
    <FilterOption @option="onOptionChange"/>

    <Activitys @info="yourself" :caption="$t('assessment')" :item="item" @reload="onLoad"/>

    <div ref="assessmentScrollToMe" v-if="this.isAssessment">
      <CRow>
        <CCol>
          <CometencyParent :objs="objs"/>
        </CCol>
      </CRow>

      <CRow class="mb-4">
        <CCol class="text-right">
          <CButton v-if="buttomControl.isSave" class="ml-2" size="sm" color="success" shape="pill" variant="outline"
                   :disabled="isAssessmentSaving"
                   @click="onSave">
            <span class="font-weight-bold pr-1"><CIcon name="cil-save"/> {{ $t('save') }} </span>
          </CButton>
          <CButton v-if="buttomControl.isSend" class="ml-2" size="sm" color="info" shape="pill" variant="outline"
                   :disabled="isAssessmentSaving"
                   @click="onSend">
            <span class="font-weight-bold pr-1"><CIcon name="cil-hand-point-up"/> {{ $t('send') }} </span>
          </CButton>
          <CButton v-if="buttomControl.isUnSend" class="ml-2" size="sm" color="danger" shape="pill" variant="outline"
                   :disabled="isAssessmentSaving"
                   @click="onUnSend">
            <span class="font-weight-bold pr-1"><CIcon name="cil-hand-point-up"/>  {{ $t('unsend') }} </span>
          </CButton>
          <CButton v-if="buttomControl.isRejected" class="ml-2" size="sm" color="dark" shape="pill" variant="outline"
                   :disabled="isAssessmentSaving"
                   @click="onRejected">
            <span class="font-weight-bold pr-1"><CIcon name="cil-loop-circular"/> {{ $t('reject') }} </span>
          </CButton>
        </CCol>
      </CRow>
    </div>

    <IDP ref="scrollToMe" v-if="this.isIdp"  :options="option"/>


  </div>
</template>

<script>


import {mapGetters} from 'vuex'
import FilterOption from "@/projects/views/E-Performances/Estimate/components/FilterOption";
import Activitys from "@/projects/views/E-Performances/Estimate/components/Activitys";
import Cometencys from "@/projects/views/E-Performances/Estimate/components/Cometencys";
import Profile from "@/projects/views/E-Performances/Estimate/components/Profile";
import CometencyParent from "@/projects/views/E-Performances/Estimate/components/CometencyParent";
import IDP from "@/projects/views/E-Performances/Estimate/components/IDP";

export default {
  name: 'EDashborad',
  components: {IDP, CometencyParent, Profile, Cometencys, Activitys, FilterOption},
  props: {
    caption: {
      type: String,
      default: ""
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {

      tabs: [
        'Calculator',
        'Shopping cart',
        'Charts'
      ],


      mapping: {
        type: "",
        item: {}
      },
      dialog: true,
      assessmentHistoryVersionTick: 0,
      option: {
        organization: "66cbe802a41ed9362a8579fa",
        agency: "00000000000000000000000",
        year: new Date().getFullYear() + 542,
      },

      item: [{
        title: this.$t('assessment'),
        type: 0,
        fields: [
          {key: "index", label: "#", _style: 'width:50px; text-align: center'},
          {key: "code", label: this.$t('staffID'), _style: 'width:100px;'},
          {key: "position", label: this.$t('department')},
          {key: "info", label: this.$t('fullname')},
          // {key:"status", label:"Gap",  _style: 'width:80px; text-align: center'},
          {key: "status", label: this.$t('process')},
          {key: "action", label: "#", _style: 'width:100px; text-align: center'},
          // {key:"action2", label: "ผล",  _style: 'width:100px; text-align: center'},

        ],
        isTimeline : true,
        historyVersion: 0,
        historys: []
      }, {
        title: this.$t('subordinate'),
        type: 1,
        fields: [
          {key: "index", label: "#", _style: 'width:50px; text-align: center'},
          {key: "code", label: this.$t('staffID'), _style: 'width:100px;'},
          // {key:"year", label:"Year",  _style: 'width:100px;'},
          // {key:"position", label:"สังกัด"},
          {key: "position", label: this.$t('department')},
          {key: "info", label: this.$t('fullname')},
          {key: "status", label: this.$t('process')},
          {key: "action", label: "#", _style: 'width:100px; text-align: center'}
        ],
        isTimeline : false,
        historyVersion: 0,
        historys: []
      }],


      profile: {},
      competency: [],
      type: 0,
      _id: null,


      isAssessment: false,
      objs: {},

      buttomControl: {
        isSave: false,
        isSend: false,
        isUnSend: false,
        isRejected: true
      },

      isAssessmentSaving: false,
      isIdp:false
    }


  },

  mounted() {
    this.onInit()
  },

  created() {

  },
  beforeDestroy() {

  },

  methods: {
    onClearData() {

    },
    onOptionChange(e) {
      this.isAssessment = false;
      this.option = e;
      this.onLoad();
    },
    //
    onInit() {
      var data = {};
      this.$store.dispatch("assessment/config", data)

      var data = {};
      this.$store.dispatch("personal/config", data)

      this.onLoad();
    },

    onLoad() {

      var body = {};
      body.yourself = true;
      body.organization = this.option.organization;
      body.year = parseInt(this.option.year);
      const yourselfRequest = this.$store.dispatch("estimate/config", body)


      var body = {};
      body.yourself = false;
      body.organization = this.option.organization;
      body.year = parseInt(this.option.year);
      const historyRequest = this.$store.dispatch("estimate/config", body)

      return Promise.all([yourselfRequest, historyRequest])

    },

    yourself(item) {
      this.isAssessment = false;
      this.isIdp = false;

      if(item.isIDP === true){

        var body = {};
        body.organization = this.option.organization;
        body.year = parseInt(this.option.year);
        body.accounts = item.value.accounts._id;

        this.$store.dispatch("idp/init", body)

      }else{
        this.objs = this.sanitizeAssessmentPayload(item.value || {});
        this.objs.type = item.type;
        //
        if (item.type === 1) {
          const activeAssessment = this.getActiveAssessmentNodeInfo(this.objs);
          if (activeAssessment && activeAssessment.node) {
            this.objs.activeAssessmentSource = activeAssessment.source;
            this.objs.activeAssessmentStatus = activeAssessment.node.status || [];
          }
        } else {

        }
        this.onCheckState();
        this.isAssessment = true;
        setTimeout(() => this.scrollToRef('assessmentScrollToMe'), 200)
      }

    },


    // change status

    onClear() {
    },
    async onRejected() {
      if (this.isAssessmentSaving) {
        return;
      }
      this.isAssessmentSaving = true;

      var data = {};
      data.status = 3;
      data._id = this.objs._id;
      data.organization = this.option.organization;
      data.year = this.option.year;

      data.accounts = this.getAssessmentActionAccountId();
      data.type = this.objs.type;

      try {
        await this.$store.dispatch("estimate/create", data)
        this.syncCurrentAssessmentHistoryRow(data.status)
        await this.onLoad()
        await this.$nextTick()
        this.syncCurrentAssessmentHistoryRow(data.status)

        this.buttomControl.isSave = true;
        this.buttomControl.isSend = false;
        this.buttomControl.isUnSend = false;
      } catch (err) {
        this.onEstimateSaveError(err);
      } finally {
        this.isAssessmentSaving = false;
      }
    },
    async onUnSend() {
      if (this.isAssessmentSaving) {
        return;
      }
      this.isAssessmentSaving = true;

      var data = {};
      data.status = 2;
      data._id = this.objs._id;
      data.organization = this.option.organization;
      data.year = this.option.year;

      data.accounts = this.getAssessmentActionAccountId();
      data.type = this.objs.type;

      try {
        await this.$store.dispatch("estimate/create", data)
        this.syncCurrentAssessmentHistoryRow(data.status)
        await this.onLoad()
        await this.$nextTick()
        this.syncCurrentAssessmentHistoryRow(data.status)

        this.buttomControl.isSave = true;
        this.buttomControl.isSend = true;
        this.buttomControl.isUnSend = false;
      } catch (err) {
        this.onEstimateSaveError(err);
      } finally {
        this.isAssessmentSaving = false;
      }
    },
    async onSave() {
      if (this.isAssessmentSaving) {
        return;
      }
      this.isAssessmentSaving = true;

      var data = {};
      data.status = 0;
      data._id = this.objs._id;
      data.organization = this.option.organization;
      data.year = this.option.year;

      data.accounts = this.getAssessmentActionAccountId();
      data.type = this.objs.type;
      if (data.type == 1) {
        data.item = this.sanitizeAssessmentPayload(this.getAssessmentActionItem());
      } else {
        data.item = this.sanitizeAssessmentPayload(this.objs.item)
      }
      this.removeAssessmentChartData(data.item)

      try {
        await this.$store.dispatch("estimate/create", data)
        this.syncCurrentAssessmentHistoryRow(data.status)
        await this.onLoad()
        await this.$nextTick()
        this.syncCurrentAssessmentHistoryRow(data.status)
        this.buttomControl.isSave = true;
        this.buttomControl.isSend = true;
        this.buttomControl.isUnSend = false;
        if (this.objs.type == 1) {
          this.buttomControl.isRejected = true;
        } else {
          this.buttomControl.isRejected = false;
        }
      } catch (err) {
        this.onEstimateSaveError(err);
      } finally {
        this.isAssessmentSaving = false;
      }
    },
    async onSend() {
      if (this.isAssessmentSaving) {
        return;
      }
      this.isAssessmentSaving = true;

      var data = {};
      data.status = 1;
      data._id = this.objs._id;
      data.organization = this.option.organization;
      data.year = this.option.year;

      data.accounts = this.getAssessmentActionAccountId();
      data.type = this.objs.type;
      if (data.type == 1) {
        data.item = this.sanitizeAssessmentPayload(this.getAssessmentActionItem());
      } else {
        data.item = this.sanitizeAssessmentPayload(this.objs.item)
      }
      this.removeAssessmentChartData(data.item)

      try {
        await this.$store.dispatch("estimate/create", data)
        this.syncCurrentAssessmentHistoryRow(data.status)
        await this.onLoad()
        await this.$nextTick()
        this.syncCurrentAssessmentHistoryRow(data.status)
        this.buttomControl.isSave = false;
        this.buttomControl.isSend = false;
        this.buttomControl.isUnSend = true;
      } catch (err) {
        this.onEstimateSaveError(err);
      } finally {
        this.isAssessmentSaving = false;
      }
    },

    onEstimateSaveError(err) {
      const status = err && err.response ? err.response.status : "-";
      const message = err && err.message ? err.message : "Assessment save failed";
      console.error("[assessment/save] request failed", {status, message});
      this.$store.commit("dialog/loading", false);
      this.$store.commit("dialog/toastM", status === 404
        ? "Assessment save failed: backend returned 404"
        : message);
      this.$store.commit("dialog/toasts", 2);
    },

    bumpAssessmentHistoryVersion(type) {
      const itemGroup = this.item[Number(type)];

      if (!itemGroup) {
        return;
      }

      this.assessmentHistoryVersionTick += 1;
      this.$set(itemGroup, "historyVersion", `${Date.now()}-${this.assessmentHistoryVersionTick}`);
      this.item = this.item.slice();
    },

    assessmentStatusIds() {
      return {
        pending: "654851a37ab25be71bbeeed6",
        save: "654851dbe41b7f46025977f6",
        send: "654851ece41b7f46025977fa",
        unsend: "670f777373effdb76e17954d",
        reject: "6723709ab9a2030e40d1b884",
        completed: "654851a37ab25be71bbeeed7"
      };
    },

    getLatestStatusEntry(statuses) {
      return Array.isArray(statuses) && statuses.length > 0 ? statuses[statuses.length - 1] : null;
    },

    getStatusId(entry) {
      const state = entry && entry.state ? entry.state : {};
      return state && state._id ? state._id.toString() : "";
    },

    getCurrentAssessmentStatusId() {
      if (this.objs && Number(this.objs.type) === 1) {
        const activeAssessment = this.getActiveAssessmentNodeInfo(this.objs);
        if (activeAssessment && activeAssessment.node) {
          return this.getStatusId(this.getLatestStatusEntry(activeAssessment.node.status));
        }
      }

      return this.getStatusId(this.getLatestStatusEntry(this.objs && this.objs.status));
    },

    getStatusTime(entry) {
      return (
        (entry || {}).timeStamp ||
        (entry || {}).updatedAt ||
        (entry || {}).createdAt ||
        null
      );
    },

    getLocaleValue(items, lang, fallback = "") {
      if (!Array.isArray(items) || items.length === 0) {
        return fallback;
      }

      const match = items.find((entry) => entry && entry.key === lang) || items[0];
      return match && match.value ? match.value : fallback;
    },

    normalizeStatusTitle(entry, statusId) {
      const state = entry && entry.state ? entry.state : {};
      const title = Array.isArray(state.title) ? state.title : [];

      if (title.length > 0) {
        return title.map((item) => Object.assign({}, item, {
          _id: item && item._id ? item._id : statusId
        }));
      }

      return [
        {key: "en", value: "-", _id: statusId},
        {key: "th", value: "-", _id: statusId}
      ];
    },

    completedStatusTitle() {
      const completedId = this.assessmentStatusIds().completed;
      return [
        {key: "en", value: "Completed", _id: completedId},
        {key: "th", value: "เสร็จสิ้น", _id: completedId}
      ];
    },

    assessmentActionStatusConfig(status) {
      const statusIds = this.assessmentStatusIds();
      const configs = {
        0: {
          id: statusIds.save,
          title: [
            {key: "en", value: "Doing", _id: statusIds.save},
            {key: "th", value: "Doing", _id: statusIds.save}
          ]
        },
        1: {
          id: statusIds.send,
          title: [
            {key: "en", value: "Send", _id: statusIds.send},
            {key: "th", value: "Send", _id: statusIds.send}
          ]
        },
        2: {
          id: statusIds.unsend,
          title: [
            {key: "en", value: "UnSend", _id: statusIds.unsend},
            {key: "th", value: "UnSend", _id: statusIds.unsend}
          ]
        },
        3: {
          id: statusIds.reject,
          title: [
            {key: "en", value: "Reject", _id: statusIds.reject},
            {key: "th", value: "Reject", _id: statusIds.reject}
          ]
        }
      };

      return configs[Number(status)] || null;
    },

    findAssessmentStatusTitleById(statusId) {
      const targetId = statusId ? statusId.toString() : "";

      if (!targetId) {
        return null;
      }

      const scanEntries = (entries) => {
        if (!Array.isArray(entries)) {
          return null;
        }

        for (let entry of entries) {
          const state = entry && entry.state ? entry.state : {};
          if (state && state._id && state._id.toString() === targetId && Array.isArray(state.title)) {
            return state.title;
          }
        }

        return null;
      };

      const scanNode = (node) => {
        if (!node) {
          return null;
        }

        const currentTitle = scanEntries(node.status);
        if (currentTitle) {
          return currentTitle;
        }

        return scanNode(node.children);
      };

      const sources = [this.objs];
      [0, 1].forEach((type) => {
        const rows = this.item[type] && Array.isArray(this.item[type].historys)
          ? this.item[type].historys
          : [];
        rows.forEach((row) => sources.push(row && row.value));
      });

      for (let source of sources) {
        const selfTitle = scanEntries(source && source.status);
        if (selfTitle) {
          return selfTitle;
        }

        const structure = Array.isArray(source && source.structure) ? source.structure : [];
        for (let node of structure) {
          const nodeTitle = scanNode(node);
          if (nodeTitle) {
            return nodeTitle;
          }
        }
      }

      return null;
    },

    createAssessmentStatusEntry(actionStatus) {
      const config = this.assessmentActionStatusConfig(actionStatus);

      if (!config) {
        return null;
      }

      return {
        state: {
          _id: config.id,
          title: this.findAssessmentStatusTitleById(config.id) || config.title
        },
        timeStamp: new Date().toISOString()
      };
    },

    appendAssessmentStatusEntry(target, type, entry) {
      if (!target || !entry) {
        return;
      }

      if (type === 1) {
        const activeAssessment = this.getActiveAssessmentNodeInfo(target);
        if (activeAssessment && activeAssessment.node) {
          if (!Array.isArray(activeAssessment.node.status)) {
            activeAssessment.node.status = [];
          }
          if (this.getStatusId(this.getLatestStatusEntry(activeAssessment.node.status)) === this.getStatusId(entry)) {
            return;
          }
          activeAssessment.node.status.push(entry);
          return;
        }
      }

      if (!Array.isArray(target.status)) {
        target.status = [];
      }
      if (this.getStatusId(this.getLatestStatusEntry(target.status)) === this.getStatusId(entry)) {
        return;
      }
      target.status.push(entry);
    },

    syncCurrentAssessmentHistoryRow(actionStatus) {
      const type = Number(this.objs && this.objs.type);
      const itemGroup = this.item[type];
      const rows = itemGroup && Array.isArray(itemGroup.historys) ? itemGroup.historys : [];
      const targetId = this.objs && this.objs._id ? this.objs._id.toString() : "";

      if (!targetId || !rows.length) {
        return;
      }

      const rowIndex = rows.findIndex((row) => {
        const rowId = row && row.value && row.value._id ? row.value._id.toString() : "";
        return rowId === targetId;
      });

      if (rowIndex < 0) {
        return;
      }

      const row = rows[rowIndex];
      const snapshot = this.sanitizeAssessmentPayload((row && row.value) || this.objs || {});
      const entry = this.createAssessmentStatusEntry(actionStatus);

      snapshot.type = type;
      this.appendAssessmentStatusEntry(snapshot, type, entry);

      const lang = this.$store.getters['setting/lang'];
      const process = this.resolveAssessmentProcess(snapshot, type, lang);
      const syncedRow = Object.assign({}, row, {
        status: process.status,
        statusId: process.statusId,
        statusTime: process.statusTime,
        assessor: process.assessor,
        value: snapshot
      });

      this.$set(rows, rowIndex, syncedRow);
      this.$set(itemGroup, "historys", rows.slice());
      this.bumpAssessmentHistoryVersion(type);
      this.objs = snapshot;
      this.$forceUpdate();
    },

    getAccountPayload(account) {
      if (!account) {
        return {};
      }

      if (account.userinfo) {
        return account;
      }

      if (account.accounts && account.accounts.userinfo) {
        return account.accounts;
      }

      return account.accounts || account;
    },

    getAccountName(account, lang) {
      const payload = this.getAccountPayload(account);
      const userinfo = payload.userinfo || {};
      const name = [
        this.getLocaleValue(userinfo.prefix, lang),
        this.getLocaleValue(userinfo.firstName, lang),
        this.getLocaleValue(userinfo.lastName, lang)
      ].filter(Boolean).join(" ").trim();

      return name || "";
    },

    getProfileAccountId() {
      const profile = this.$store.getters['personal/profile'] || {};
      return profile && profile._id ? profile._id.toString() : "";
    },

    getNodeAccountId(node) {
      return node && node.accounts && node.accounts._id ? node.accounts._id.toString() : "";
    },

    findAssessmentNodeInfo(item, targetId) {
      const target = targetId ? targetId.toString() : "";
      const structure = Array.isArray(item && item.structure) ? item.structure : [];

      if (!target) {
        return null;
      }

      for (let node of structure) {
        if (this.getNodeAccountId(node) === target) {
          return {node: node, source: "assessor1"};
        }

        if (node && node.children && this.getNodeAccountId(node.children) === target) {
          return {node: node.children, source: "assessor2"};
        }

        if (
          node &&
          node.children &&
          node.children.children &&
          this.getNodeAccountId(node.children.children) === target
        ) {
          return {node: node.children.children, source: "assessor3"};
        }
      }

      return null;
    },

    getActiveAssessmentNodeInfo(item) {
      return this.findAssessmentNodeInfo(item, this.getProfileAccountId());
    },

    getAssessmentActionAccountId() {
      if (this.objs && this.objs.type == 1) {
        const activeAssessment = this.getActiveAssessmentNodeInfo(this.objs);
        if (activeAssessment && activeAssessment.node) {
          return this.getNodeAccountId(activeAssessment.node);
        }
        return this.getProfileAccountId();
      }

      return this.objs && this.objs.accounts && this.objs.accounts._id
        ? this.objs.accounts._id
        : "";
    },

    getAssessmentActionItem() {
      const activeAssessment = this.getActiveAssessmentNodeInfo(this.objs);
      return activeAssessment && activeAssessment.node ? activeAssessment.node.item : [];
    },

    removeAssessmentChartData(item) {
      if (!Array.isArray(item) || !item[0]) {
        return;
      }

      delete item[0].points;
      delete item[0].datasets;
    },

    sanitizeAssessmentPayload(value) {
      if (value === undefined || value === null) {
        return value;
      }

      const seen = new WeakSet();
      const blockedKeys = new Set([
        "datasets",
        "points",
        "_meta",
        "_chart",
        "_model",
        "_view",
        "$el",
        "$children",
        "$parent",
        "__ob__"
      ]);

      const serialized = JSON.stringify(value, (key, payload) => {
        if (blockedKeys.has(key)) {
          return undefined;
        }

        if (typeof payload === "function") {
          return undefined;
        }

        if (payload && typeof payload === "object") {
          if (seen.has(payload)) {
            return undefined;
          }
          seen.add(payload);
        }

        return payload;
      });

      return serialized ? JSON.parse(serialized) : serialized;
    },

    createProcessStatus(entry, person, source) {
      const statusId = this.getStatusId(entry);
      return {
        status: this.normalizeStatusTitle(entry, statusId),
        statusId: statusId,
        statusTime: this.getStatusTime(entry),
        assessor: person || "",
        source: source
      };
    },

    createCompletedProcessStatus(entry) {
      const statusIds = this.assessmentStatusIds();
      return {
        status: this.completedStatusTitle(),
        statusId: statusIds.completed,
        statusTime: this.getStatusTime(entry),
        assessor: "",
        source: "completed"
      };
    },

    resolveAssessmentProcess(item, type, lang) {
      const statusIds = this.assessmentStatusIds();
      const selfEntry = this.getLatestStatusEntry(item && item.status);
      const selfStatusId = this.getStatusId(selfEntry);
      const structure = Array.isArray(item && item.structure) ? item.structure : [];
      const firstAssessor = structure[0] || {};
      const firstAssessorEntry = this.getLatestStatusEntry(firstAssessor.status);
      const firstAssessorStatusId = this.getStatusId(firstAssessorEntry);
      const secondAssessor = firstAssessor.children || {};
      const secondAssessorEntry = this.getLatestStatusEntry(secondAssessor.status);
      const secondAssessorStatusId = this.getStatusId(secondAssessorEntry);
      const hasSecondAssessor = Boolean(secondAssessor && secondAssessor.accounts);
      const isCompleted = selfStatusId === statusIds.send &&
        firstAssessorStatusId === statusIds.send &&
        (!hasSecondAssessor || secondAssessorStatusId === statusIds.send);

      if (isCompleted) {
        return this.createCompletedProcessStatus(secondAssessorEntry || firstAssessorEntry || selfEntry);
      }

      if (type === 1) {
        const activeAssessment = this.getActiveAssessmentNodeInfo(item);
        if (activeAssessment && activeAssessment.node) {
          const activeEntry = this.getLatestStatusEntry(activeAssessment.node.status);
          return this.createProcessStatus(
            activeEntry,
            this.getAccountName(activeAssessment.node.accounts, lang),
            activeAssessment.source
          );
        }
      }

      if (selfStatusId !== statusIds.send) {
        return this.createProcessStatus(selfEntry, this.getAccountName(item && item.accounts, lang), "self");
      }

      if (!firstAssessorEntry || firstAssessorStatusId !== statusIds.send) {
        return this.createProcessStatus(firstAssessorEntry || selfEntry, this.getAccountName(firstAssessor.accounts, lang), "assessor1");
      }

      if (!secondAssessor || (!secondAssessor.accounts && !Array.isArray(secondAssessor.status))) {
        return this.createCompletedProcessStatus(firstAssessorEntry);
      }

      if (!secondAssessorEntry || secondAssessorStatusId !== statusIds.send) {
        return this.createProcessStatus(secondAssessorEntry || firstAssessorEntry, this.getAccountName(secondAssessor.accounts, lang), "assessor2");
      }

      return this.createCompletedProcessStatus(secondAssessorEntry);
    },

    resolveAssessmentDisable(item, type, process) {
      if (type === 0) {
        return true;
      }

      const profile = this.$store.getters['personal/profile'] || {};
      const profileId = profile._id ? profile._id.toString() : "";
      const structure = Array.isArray(item && item.structure) ? item.structure : [];
      const firstAssessor = structure[0] || {};

      if (process.source === "assessor1") {
        const assessorId = firstAssessor.accounts && firstAssessor.accounts._id
          ? firstAssessor.accounts._id.toString()
          : "";
        return Boolean(profileId && assessorId === profileId);
      }

      if (process.source === "assessor2" || process.source === "assessor3" || process.source === "completed") {
        return true;
      }

      return false;
    },

    mapAssessmentHistoryItem(item, type, lang) {
      const account = this.getAccountPayload(item && item.accounts);
      const process = this.resolveAssessmentProcess(item, type, lang);

      return {
        type: type,
        year: item && item.year,
        code: account.code || "",
        info: this.getAccountName(account, lang),
        position: item && item.position && item.position.agency ? item.position.agency.title : [],
        disable: this.resolveAssessmentDisable(item, type, process),
        status: process.status,
        statusId: process.statusId,
        statusTime: process.statusTime,
        assessor: process.assessor,
        value: item
      };
    },

    findObjectByIdInArray(dataArray, targetId) {
      if (!Array.isArray(dataArray)) {
        return null;
      }

      for (let obj of dataArray) {

        // ค้นหา _id ใน accounts
        if (obj.accounts && obj.accounts._id === targetId) {
          return obj;
        }
        // ค้นหา _id ใน children.accounts
        if (obj.children && obj.children.accounts && obj.children.accounts._id === targetId) {
          return obj.children;
        }

        // // ค้นหา _id ใน children.accounts
        if (obj.children && obj.children.children && obj.children.children.accounts && obj.children.children.accounts._id === targetId) {
          return obj.children.children;
        }
      }
      // ถ้าไม่เจอให้ return null
      return null;
    },
    // end change status


    //
    onCheckState() {
      this.buttomControl.isSave = false;
      this.buttomControl.isSend = false;
      this.buttomControl.isUnSend = false;
      this.buttomControl.isRejected = false;

      const currentStatus = this.getCurrentAssessmentStatusId();
      const statusIds = this.assessmentStatusIds();

      if (currentStatus == statusIds.reject) {
        this.buttomControl.isSave = true;
      }

      if (currentStatus == statusIds.pending) {
        this.buttomControl.isSave = true;
      }
      // สามารถทำการ บันทึกได้

      if (currentStatus == statusIds.save) {
        this.buttomControl.isSave = true;
        this.buttomControl.isSend = true;
      }
      // สามารถทำการ ส่งได้
      if (currentStatus == statusIds.send) {
        const firstStructureStatus = (
          this.objs &&
          this.objs.structure &&
          this.objs.structure[0] &&
          Array.isArray(this.objs.structure[0].status)
        ) ? this.objs.structure[0].status : [];

        this.buttomControl.isUnSend = true;
        if (firstStructureStatus.length > 1 && this.objs.type == 0) {
          this.buttomControl.isUnSend = false;
        } else {
          this.buttomControl.isUnSend = true;
        }
        if (firstStructureStatus.length > 1) {
          this.buttomControl.isUnSend = false;
        }
      }


      if (currentStatus == statusIds.unsend) {
        this.buttomControl.isSave = true;
        this.buttomControl.isSend = true;
      }

      if (this.objs.type == 1) {
        this.buttomControl.isRejected = true;
        this.buttomControl.isUnSend = currentStatus == statusIds.send && this.buttomControl.isUnSend;
      }
      // เปรียบเทียบ

      // ยอมรับ

      // ไม่ยอมรับ

    },

    //

    findAccountById(id, data) {
      // ฟังก์ชันค้นหาในแต่ละชั้นของข้อมูล
      function searchAccounts(obj) {
        if (obj._id === id) {
          return obj;
        }
        if (obj.accounts && typeof obj.accounts === 'object') {
          // ค้นหาใน accounts
          const result = searchAccounts(obj.accounts);
          if (result) return result;
        }
        if (Array.isArray(obj)) {
          // ค้นหาในอาร์เรย์
          for (const item of obj) {
            const result = searchAccounts(item);
            if (result) return result;
          }
        }
        return null;
      }

      // เริ่มค้นหาจากข้อมูลที่ให้มา
      return searchAccounts(data);
    },
    onCreatetChartPoint(objs) {
      var chart = [];
      for (var k = 0; k < objs.length; k++) {
        var level = objs[k].levels
        var point = 0;
        for (var l = 0; l < level.length; l++) {
          var checked = level[l].item.filter(item => {
            return (item.checked == false)
          })
          if (checked.length == 0) {
            point = point + 1
          } else {
            break;
          }
        }
        chart.push(point)

      }
      return chart;
    },
    onSetData(value) {
      for (var i = 0; i < value.length; i++) {
        //core
        var item = value[i].item
        var datasets = []
        var point = []

        var cc = item[0].item
        var objs = this.onCreatetChartPoint(cc)
        var points = {};
        points.accounts = value[i].accounts.accounts
        points.objs = objs
        point.push(points)


        var objData = {
          label: 'Self',
          backgroundColor: 'rgba(179,181,198,0.2)',
          borderColor: 'rgb(6,29,245)',
          pointBackgroundColor: 'rgba(179,181,198,1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(179,181,198,1)',
          tooltipLabelColor: 'rgba(179,181,198,1)',
          data: objs
        };
        datasets.push(objData)

        var structure = value[i].structure[0];
        var cc = structure.item[0].item
        var objs = this.onCreatetChartPoint(cc)
        var points = {};
        points.accounts = value[i].structure[0].accounts.accounts
        points.objs = objs
        point.push(points)

        var objData = {
          label: 'Assessor 1',
          backgroundColor: 'rgba(179,181,198,0.2)',
          borderColor: 'rgb(229,6,245)',
          pointBackgroundColor: 'rgba(179,181,198,1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(179,181,198,1)',
          tooltipLabelColor: 'rgba(179,181,198,1)',
          data: objs
        };
        datasets.push(objData)

        if (structure.children.item.length > 0) {
          var cc = structure.children.item[0].item
          var objs = this.onCreatetChartPoint(cc)
          var points = {};
          points.accounts = structure.children.accounts.accounts
          points.objs = objs
          point.push(points)
          var objData = {
            label: 'Assessor 2',
            backgroundColor: 'rgba(179,181,198,0.2)',
            borderColor: 'rgb(0,255,108)',
            pointBackgroundColor: 'rgba(179,181,198,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(179,181,198,1)',
            tooltipLabelColor: 'rgba(179,181,198,1)',
            data: objs
          };
          datasets.push(objData)
        }

        item[0].datasets = datasets
        item[0].points = point
      }
      return value
    },
    scrollToRef(refName = 'scrollToMe') {
      this.$nextTick(() => {
        const target = this.$refs[refName]

        if (target) {
          const element = target.$el || target
          element.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      })
    },


  },


  computed: {
    ...mapGetters({
      objsLang: "setting/lang",
      userId: "auth/userId",
      // objsItem : "assessment/assessment",
      // objsProfile : "personal/profile",

      objsYourself: "estimate/yourself",
      objsHistory: "estimate/history",
      isReload: "estimate/isReload",



      objsIdp: "idp/idp"



    }),
  },

  watch: {
    objsLang(value) {

      this.item[0].title = this.$t('assessments');
      this.item[0].fields = [
        {key: "index", label: "#", _style: 'width:50px; text-align: center'},
        {key: "code", label: this.$t('staffID'), _style: 'width:100px;'},
        {key: "position", label: this.$t('department')},
        {key: "info", label: this.$t('fullname')},
        // {key:"status", label:"Gap",  _style: 'width:80px; text-align: center'},
        {key: "status", label: this.$t('process')},
        {key: "action", label: "#", _style: 'width:100px; text-align: center'},
        // {key:"action2", label: "ผล",  _style: 'width:100px; text-align: center'},

      ];

      this.item[1].title = this.$t('subordinate');
      this.item[1].fields = [
        {key: "index", label: "#", _style: 'width:50px; text-align: center'},
        {key: "code", label: this.$t('staffID'), _style: 'width:100px;'},
        // {key:"year", label:"Year",  _style: 'width:100px;'},
        // {key:"position", label:"สังกัด"},
        {key: "position", label: this.$t('department')},
        {key: "info", label: this.$t('fullname')},
        {key: "status", label: this.$t('process')},
        {key: "action", label: "#", _style: 'width:100px; text-align: center'}
      ];

      //   this.onLoad()
      //   this.$store.commit("estimate/isReload", false)
    },
    isReload(value) {
      if (value == true) {
        this.onLoad()
        this.$store.commit("estimate/isReload", false)
      }
    },
    objsProfile(value) {
      this.profile = value;
    },

    objsItem(value) {
      // delete value._id;
      this.competency = value.item;
    },

    objsYourself(value) {
      value = this.onSetData(value)

      for (var i = 0; i < value.length; i++) {
        //core
        var item = value[i].item
        var datasets = []

        var cc = item[0].item
        var objs = this.onCreatetChartPoint(cc)

        var objData = {
          label: 'Self',
          backgroundColor: 'rgba(179,181,198,0.2)',
          borderColor: 'rgb(6,29,245)',
          pointBackgroundColor: 'rgba(179,181,198,1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(179,181,198,1)',
          tooltipLabelColor: 'rgba(179,181,198,1)',
          data: objs
        };
        datasets.push(objData)

        var structure = value[i].structure[0];
        var cc = structure.item[0].item
        var objs = this.onCreatetChartPoint(cc)

        var objData = {
          label: 'Assessor 1',
          backgroundColor: 'rgba(179,181,198,0.2)',
          borderColor: 'rgb(229,6,245)',
          pointBackgroundColor: 'rgba(179,181,198,1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(179,181,198,1)',
          tooltipLabelColor: 'rgba(179,181,198,1)',
          data: objs
        };
        datasets.push(objData)

        if (structure.children.item > 0) {
          var cc = structure.children.item[0].item
          var objs = this.onCreatetChartPoint(cc)
          var objData = {
            label: 'Assessor 2',
            backgroundColor: 'rgba(179,181,198,0.2)',
            borderColor: 'rgb(0,255,108)',
            pointBackgroundColor: 'rgba(179,181,198,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(179,181,198,1)',
            tooltipLabelColor: 'rgba(179,181,198,1)',
            data: objs
          };
          datasets.push(objData)
        }

        item[0].datasets = datasets
      }
      var lang = this.$store.getters['setting/lang']
      var items = Array.isArray(value)
        ? value.map(item => this.mapAssessmentHistoryItem(item, 0, lang))
        : [];
      this.$set(this.item[0], "historys", items);
      this.bumpAssessmentHistoryVersion(0);
    },
    objsHistory(value) {
      value = this.onSetData(value)
      // this.historys = [];
      var lang = this.$store.getters['setting/lang']
      var items = Array.isArray(value)
        ? value.map(item => this.mapAssessmentHistoryItem(item, 1, lang))
        : [];
      this.$set(this.item[1], "historys", items);
      this.bumpAssessmentHistoryVersion(1);
    },


    objsIdp(value){
      this.isIdp = true;
      setTimeout(() => this.scrollToRef('scrollToMe'), 200)
    }
  }


}
</script>
<style>
</style>
